<div class="container p-4" style="    max-width: 1320px;">
    <div class="card">
        <h3>Payment Mehtod (Bank Transfer)</h3>
        <br>
        <div *ngIf="this.methodSettings?.active=='1'">
            <div class="text-center m-auto" style="max-width: 500px;margin: auto;">

                <p >
Please use the following information to pay your order.<br>
                </p>
                <table class="table">
                    <tr>
                        <td class="text-left"><b>Instructions</b></td>
                    </tr>
                    <tr>
                        <td>
                            {{this.methodSettings?.instructions}}
                        </td>
                    </tr>
                </table>
            </div>


        </div>
        <div *ngIf="this.methodSettings?.active == '0'">
            <div class="alert alert-danger">Sorry, this payment method is not available.</div>
        </div>


    </div>


</div>

